const chapters = {
  intro: 'Intro',
  one: '1',
  two: '2',
  three: '3',
  four: '4',
  five: '5',
  six: '6',
  outro: 'Avslutning',
  offset: {
    one: 'Intro',
    two: '1',
    three: '2',
    four: '3',
    five: '4',
    six: '5',
    outro: '6'
  },  
};

export default chapters;
